import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { ApiChannel } from 'core/constants';
import { buildHeaders, XmStore } from 'core/services';
import { HeroBannerInfo } from './models';
import { StoreAction } from 'store/actions';

@Injectable()
export class HeroBannerApi {
    public static getHeroBannerInfo(_xmStore: XmStore, http: HttpClient): Observable<HeroBannerInfo> {
        return http.get('/account/herobanner', {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: BannerResponse) => HeroBannerInfo.create<HeroBannerInfo>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_HERO_BANNER_INFO] = HeroBannerApi.getHeroBannerInfo;
